
import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { ThemeContext } from '../context/ThemeContext';
import { content } from '../content';
import example1 from "../images/example1.jpg";
import example2 from "../images/example2.jpg";
import example3 from "../images/example3.jpg";
import example4 from "../images/example4.jpg";
import example5 from "../images/example5.jpg";
import example6 from "../images/example6.jpg";

const Examples = () => {
  const { language } = useContext(LanguageContext);
  const { theme } = useContext(ThemeContext);
  const examplesContent = content[language].examples;

  const examples = [
    { id: 1, src: example1, alt: "Example 1" },
    { id: 2, src: example2, alt: "Example 2" },
    { id: 3, src: example3, alt: "Example 3" },
    { id: 4, src: example4, alt: "Example 4" },
    { id: 5, src: example5, alt: "Example 5" },
    { id: 6, src: example6, alt: "Example 6" },
  ];

  return (
    <section id="examples" className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-gray-800' : 'bg-gray-100'}`}>
      <div className="container mx-auto">
        <h2 className={`text-3xl md:text-4xl font-extrabold text-center mb-10 md:mb-12 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
          {examplesContent.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {examples.map((example) => (
            <div key={example.id} className="rounded-lg shadow-xl overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <img src={example.src} alt={example.alt} className="w-full h-56 sm:h-64 object-cover"/>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Examples;
